import http from "../../http";

/** 小区片区 — /resident/api/resident/houseEstate */
const BASE = "/resident/api/resident/houseEstate";

const estate = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectList(r) {
    return http.get(`${BASE}/list`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  updateSortNo(r) {
    return http.tip.post(`${BASE}/updateSortNo`, r);
  },
  selectStaffList(r) {
    return http.get(`${BASE}/selectStaffList`, r);
  },
  saveStaffList(r) {
    return http.payload(`${BASE}/saveStaffList`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
};

export default estate;
